/**
 * Component Registry for Blue Haven
 * 
 * Inherits from @vibesites-repli-training/theme-blue-haven and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-repli-training/theme-blue-haven/registry';
import { Header } from './components/Header';
import { ManualFloorplans } from './components/ManualFloorplans';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  ManualFloorplans,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
